import styled from 'styled-components';
import { THUMBNAIL_BORDER_RADIUS } from './constants';
import { ThumbnailStyleProps } from './types';

export const Root = styled.div<ThumbnailStyleProps>`
  background-color: transparent;
  border-radius: ${THUMBNAIL_BORDER_RADIUS};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  position: relative;

  ${({ $basis }) => `${$basis}: 100%;`}
`;
